import type { HistoryItem, HistoryStatus } from '@/types/history';

const STATUS_COPY: Record<HistoryStatus, string> = {
  printed: 'Dicetak',
  shared_pdf: 'Disimpan PDF',
  shared_wa: 'Dikirim WhatsApp',
  selesai_belum_dicetak: 'Selesai, belum dicetak',
  belum_dicetak: 'Belum dicetak',
};

const MONTHS = [
  'Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun',
  'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des',
] as const;

export function isPendingPrint(item: HistoryItem): boolean {
  return item.printStatus === 'belum_dicetak'
    || item.printStatus === 'selesai_belum_dicetak';
}

export function historyStatusSentence(
  item: HistoryItem,
  todayIso: string,
): string {
  return `${STATUS_COPY[item.printStatus]} · dipilih ${relativeSelectionDate(
    item.approvedDate,
    todayIso,
  )}`;
}

function relativeSelectionDate(dateIso: string, todayIso: string): string {
  if (dateIso === todayIso) return 'hari ini';
  const today = new Date(`${todayIso}T00:00:00Z`);
  const date = new Date(`${dateIso}T00:00:00Z`);
  const days = Math.round((today.getTime() - date.getTime()) / 86_400_000);
  if (days === 1) return 'kemarin';

  const [, month, day] = dateIso.split('-').map(Number);
  const monthName = MONTHS[(month ?? 1) - 1] ?? '';
  return `${day} ${monthName}`;
}
